import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Toggle from "../../components/Toggle";

const NoDigitalInvoice = () => {
  return (
    <div className="overflow-x-hidden">
      <div className="flex flex-col xl:flex-row items-start justify-between">
        <h1 className="text-navy-blue text-2xl font-bold">
          Payments - Digital Invoice
        </h1>

        <div className="flex sm:flex-row flex-col justify-center items-center">
          <Toggle />
        </div>
      </div>
      <div className="bg-white min-h-screen md:max-w-full max-w-72 mt-8 px-5 overflow-hidden">
        <h1 className="font-bold lg:text-[50px] text-xl md:text-3xl lg:w-[715px] pt-4">
          <span className="block leading-[75px]">
            Whether you are a freelancer or a creator, this is the best way to
            receive money from your clients.
          </span>
        </h1>
        <Link to="/payments/digital-invoice/create-invoice">
          <button className="text-white px-3 md:px-0 bg-primary md:w-[272px] h-[42px] text-base font-normal rounded-[10px] mt-4 flex items-center justify-center gap-2">
            Create a digital invoice
            <span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.51423 11.5917L1.95122 6.02863C1.68293 5.76033 1.68293 5.32535 1.95122 5.05708L2.60006 4.40825C2.8679 4.14041 3.30199 4.13989 3.57046 4.4071L8.00001 8.8159L12.4295 4.4071C12.698 4.13989 13.1321 4.14041 13.3999 4.40825L14.0488 5.05708C14.3171 5.32538 14.3171 5.76036 14.0488 6.02863L8.4858 11.5917C8.2175 11.8599 7.78252 11.8599 7.51423 11.5917Z"
                  fill="white"
                />
              </svg>
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NoDigitalInvoice;
